import React from 'react';
import '../App.css';

const DocumentList = () => {
  const pdfFiles = [
    { title: "Plan Anual de Desarrollo de Educación Municipal de Independencia PADEM 2024", url: "/pdfs/PADEM_2024.pdf" },
    { title: "Proyecto Educativo 2022-2025", url: "/pdfs/Proyecto Educativo.pdf" },
    { title: "REGLAMENTO DE EVALUACIÓN, CALIFICACIÓN Y PROMOCIÓN 2023-2024", url: "/pdfs/REGLAMENTO DE EVALUACIÓN 2023.pdf" },
    { title: "REGLAMENTO INTERNO DE CONVIVENCIA ESCOLAR ESCUELA NUEVA ZELANDIA 2026-2027", url: "/pdfs/RICE ACTUALIZADO 2026 10-06.pdf" },
    { title: "Protocolo de prohibición y regulación de dispositivos móviles electrónicos en el contexto escolar", url: "/pdfs/Protocolo escolar.pdf" },
  ];

  return (
    <div id="documentos" className="documentos-container">
      <h2 className="junaeb-title">Documentos Institucionales</h2>
      <div className="pdf-list-container">
        {pdfFiles.map((pdf, index) => (
          <div key={index} className="pdf-card">
            <a href={pdf.url} target="_blank" rel="noopener noreferrer">
              {pdf.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentList;

